// extracted by mini-css-extract-plugin
module.exports = {"isLiked":"FavoriteButton_isLiked__z3drW","isLikedAnimation":"FavoriteButton_isLikedAnimation__hYaZK","activeAnimation":"FavoriteButton_activeAnimation__lyrta"};